import React, { useEffect, useMemo, useState } from 'react';
import { readDataHealth } from '../api/dataHealth';

export default function DataHealthPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    readDataHealth().then(setRows).catch(e => setError(e.message || 'Failed')).finally(() => setLoading(false));
  }, []);
  const summary = useMemo(() => ({
    total: rows.length,
    current: rows.filter(r => r.has2026Data).length,
    stale: rows.filter(r => !r.has2026Data).length,
  }), [rows]);
  if (loading) return <div style={{padding:24}}>Loading data health…</div>;
  if (error) return <div style={{padding:24}}>Unable to load data health: {error}</div>;
  return <div style={{padding:24}}>
    <h1>Data health</h1>
    <p>Latest coverage in Azure PostgreSQL by indicator. Total: {summary.total} · With 2026 data: {summary.current} · Older: {summary.stale}</p>
    <div style={{overflowX:'auto'}}>
      <table style={{width:'100%',borderCollapse:'collapse'}}>
        <thead><tr><th>Indicator</th><th>Oldest date</th><th>Latest date</th><th>2026</th><th>Records</th><th>Geo units</th></tr></thead>
        <tbody>{rows.map(r => <tr key={r.indicatorName}>
          <td>{r.indicatorName}</td><td>{r.oldestDate || '—'}</td><td>{r.latestDate || '—'}</td>
          <td>{r.has2026Data ? 'Yes' : 'No'}</td><td>{Number(r.records || 0).toLocaleString()}</td><td>{Number(r.geoUnits || 0).toLocaleString()}</td>
        </tr>)}</tbody>
      </table>
    </div>
  </div>;
}
